import { CANCELLATION_POLICY, CancellationPolicyView } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';

/** Settings · Appointment & booking › Cancellation policy (spec 16 §5). */
export function SettingsCancellationPolicyPage() {
  return <CancellationPolicyView value={CANCELLATION_POLICY} location={useWorkspaceLabel()} />;
}
